import React, { useEffect, useContext, useState } from 'react';
import Spin from 'antd/lib/spin';
import Radio from 'antd/lib/radio';
import Select from 'antd/lib/select';
import { getDriverInfractions } from '../../../api/driverAPI';
import InfractionsTable from './InfractionsTable';
import { FormContext } from '../../metadata/MDForm';
import { ModelContext } from '../../metadata/ModelSource';
import { GlobalStateContext } from '../../../context/GlobalStateProvider';
import InfractionsMobile from './InfractionsMobile';
import { Row, Col} from 'antd';

const { Option } = Select;

const RadioButtons = ({ buttons }) => {
  return buttons.map((button, index) => {
    return (
      <Radio.Button
        className="secondary-button"
        style={{ width: '100px' }}
        key={index}
        value={button.type}
      >
        <div style={{ textAlign: 'center' }}>{button.label}</div>
      </Radio.Button>
    );
  });
};

export const DriverInfractions = ({ props }) => {
  const applicationModel = useContext(ModelContext);
  const formContext = useContext(FormContext);
  const [driverInfractionCds, setDriverInfractionCds] = useState([]);

  const { isMobile, isTablet, changeDriverInfraction} = useContext(GlobalStateContext);

  const { prefix } = formContext;
  const prefixPath = `${prefix}driverInfo.driverPoints`;

  const {
    data: {
      basicPolicy: { productVersionIdRef, inceptionDt },
    },
  } = applicationModel;

  const hasActiveInfractions = () => {
    const driverPoints = applicationModel.getValue(prefixPath);
    if (driverPoints === undefined)
      return 'no';
    const activePoints = driverPoints.filter((infraction) => infraction.status === 'Active');
    return activePoints.length ? 'yes' : 'no';
  }

  const [selection, setSelection] = useState(()=>{
     return hasActiveInfractions();
  });

  const getInfractions = async () => {
    const date = inceptionDt.replace(/-/gi, '');
    try{
      return await getDriverInfractions(productVersionIdRef, date).then((res) => {
        return setDriverInfractionCds(res.data.driverInfraction);
      });
    }catch(e){
      //todo do something if the api call fails and no infraction cds are returned
    }

  };

  useEffect(() => {
    if (selection === 'no') {
      let container = applicationModel.getValue(prefixPath);

      if (container === undefined) return

      if (container.length > 0) {
        container.forEach((infraction) => {
            infraction.status = 'Deleted';
        });
        applicationModel.modification();
      }
    }
  }, [selection]);

  useEffect(() => {
    getInfractions();
  }, []);

  if (
    !driverInfractionCds ||
    !Array.isArray(driverInfractionCds) ||
    driverInfractionCds.length <= 0
  ) {
    return <Spin spinning />;
  }

  const buttons = [
    {
      type: 'yes',
      label: 'Yes',
    },
    {
      type: 'no',
      label: 'No',
    },
  ];

  const onChange = (e) => {
    setSelection(e.target.value);
    //TODO: if value is set to NO then set all the infractions to deleted
  };

  return (
    <div>
      <p>
        Infractions are driving violations recorded against the driver.
        Each state determines how long infractions remain in the driver's record.
      </p>
        <div>
        <Row>
          <Col span ={isMobile? 24: isTablet? 16:  19} >
          <p>
            Does this driver have any driver infractions within the last 5
            years?
          </p>
        </Col>
         <Col span= {isMobile? 24: isTablet ? 8 : 5}
             style={{paddingTop:isMobile? '10px': '', paddingLeft: isTablet? '3em': isMobile? '1em' :'',alignContent:'right'}}>
          <Radio.Group
            defaultValue={selection}
            onChange={onChange}
            buttonStyle="solid"
            style={{ display: 'flex' }}
          >
            <RadioButtons buttons={buttons} />
          </Radio.Group>
        </Col>
      </Row>
        </div>
      <div style={{ marginTop: '30px' }}>
        {selection === 'yes' && changeDriverInfraction === false && (
          <InfractionsTable
            driverInfractionCds={driverInfractionCds}
            formContext={formContext}
          />
        )}
        {selection === 'yes' && changeDriverInfraction === true && (
          <InfractionsMobile
            driverInfractionCds={driverInfractionCds}
            formContext={formContext}
          />
        )}
      </div>
    </div>
  );
};
